import { createFileRoute } from "@tanstack/react-router";
import SaintFasterPathWebinarPage from "@/pages/SaintFasterPathWebinarPage";
export const Route = createFileRoute("/saint-faster-path-webinar")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS Info Session | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Register for our free Blue Cross Blue Shield mental health info session. Learn how 5-day fMRI-guided SAINT® TMS may help treatment-resistant depression.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS Info Session | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Register for our free Blue Cross Blue Shield mental health info session. Learn how 5-day fMRI-guided SAINT® TMS may help treatment-resistant depression.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-faster-path-webinar",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-faster-path-webinar",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintFasterPathWebinarPage />;
}
